/**
 * Class to store the OPO information coming from the API
 */
export class Opo {
  id: string;
  name: string;
  code: string;

  static fieldsToMap = {
    direct: [
      'id',
      'code',
      'name'
    ]
  }

  static buildFromAPI(record: any): Opo {
    const opo = new Opo();
    record = record || {};

    Opo.fieldsToMap.direct.forEach((k) => {
      opo[k] = record[k];
    });

    return opo;
  }
}